module.exports = __webpack_public_path__ + "img/2013.216c8758.png";